<template>
  <a-modal
    centered
    v-model:visible="showVideoModal"
    :title="videoToPreview?.name || 'Title'"
    :footer="null"
    id="valiadtetb-upload-video-preview-modal"
  >
    <video
      class="w-100"
      controls
      :src="videoToPreview?.fileURL"
      id="valiadtetb-uploaded-video"
    ></video>
  </a-modal>
  <a-modal
    id="validatetb-upload-videos-vald-modal"
    :visible="showUploadModal"
    title="Upload Video(s) Validation"
    width="100%"
    wrap-class-name="full-modal"
    destroy-on-close
    @cancel="handleUploadModalCancel"
  >
    <template #footer>
      <div class="d-flex justify-content-end">
        <a-button class="mr-2" @click="handleUploadModalCancel">
          Cancel
        </a-button>
        <template v-if="showModelVersion">
          <a-button
            v-if="step > 1"
            class="mr-2"
            :disabled="isUploading"
            @click="handleBack"
          >
            Back
          </a-button>
          <a-button
            type="primary"
            :loading="isUploading"
            :disabled="isProceedButtonDisabled"
            @click="handleOk"
          >
            {{ getButtonText }}
          </a-button>
        </template>
        <template v-else>
          <a-button
            type="primary"
            :loading="isUploading"
            :disabled="isProceedButtonDisabled"
            @click="handleOk"
          >
            {{ getButtonText }}
          </a-button>
        </template>
      </div>
    </template>
    <template v-if="showModelVersion && step === 1">
      <a-typography-title :level="4" class="ml-2 mt-2">
        {{ modelChoice ? modelChoice : '' }}
      </a-typography-title>
      <a-table
        class="mt-3"
        :columns="ModelVersionAiAnnotationColumns"
        :data-source="sortedModelVersionList"
        :row-selection="rowSelection"
        :row-key="'id'"
        :scroll="{
          y: '40vh',
          x: true,
        }"
        :pagination="false"
      >
        <template #emptyText>
          <div
            id="no-models-found"
            style="height: 35vh"
            class="d-flex flex-column align-items-center justify-content-center"
          >
            <laptop-outlined style="font-size: 40px" />
            <span class="mt-2">No Models Found</span>
          </div>
        </template>
        <template #bodyCell="{ column, text, record, index }">
          <template v-if="column.dataIndex === 'description'">
            {{ text }}
          </template>

          <template v-if="column.dataIndex === 'date'">
            {{ text ? dateHelper.formatDate(text) : '-' }}
          </template>

          <template v-if="column.dataIndex === 'version'">
            {{ text }}
          </template>
        </template>
      </a-table>
    </template>
    <template v-else>
      <a-row>
        <a-col
          :xs="24"
          :sm="24"
          :md="12"
          :lg="12"
          :xl="12"
          style="height: 30vh !important; margin: 0 auto"
        >
          <a-upload-dragger
            :fileList="[]"
            name="file"
            multiple
            :beforeUpload="(f) => false"
            @change="handleAddFile"
            :class="{
              'disable-click': isUploading,
            }"
            accept=".mkv,.mp4"
            id="validatetb-upload-video-dragger"
          >
            <p class="ant-upload-drag-icon">
              <inbox-outlined></inbox-outlined>
            </p>
            <p class="ant-upload-text">
              Click or drag file to this area to upload
            </p>
          </a-upload-dragger>
        </a-col>
      </a-row>
      <a-row>
        <a-col
          :xs="24"
          :sm="24"
          :md="12"
          :lg="12"
          :xl="12"
          class="d-flex flex-column mx-auto"
        >
          <div class="list-container">
            <a-list
              item-layout="horizontal"
              :data-source="fileList"
              size="small"
              rowKey="uid"
              id="validatetb-upload-video-files-list"
            >
              <template #renderItem="{ item, index }">
                <a-list-item>
                  <a-list-item-meta
                    :title="item.name"
                    :description="getFileSize(item.size)"
                    class="d-flex align-items-center"
                    :id="'validatetb-upload-video-size' + index"
                  >
                    <template #avatar class="d-flex">
                      <video
                        :src="item.fileURL"
                        width="50"
                        class="mt-1"
                      ></video>
                    </template>
                  </a-list-item-meta>
                  <template #actions>
                    <a-tooltip title="Preview file">
                      <eye-outlined
                        class="text-primary clickable"
                        :class="{
                          'disable-click': isDisabled,
                        }"
                        @click="handlePreview(item)"
                        :id="'validatetb-upload-video-preview' + index"
                      />
                    </a-tooltip>
                    <a-tooltip title="Remove file">
                      <delete-outlined
                        :class="{
                          'disable-click': isDisabled,
                        }"
                        class="text-danger clickable"
                        @click="handleRemove(item)"
                        :id="'validatetb-upload-video-delete' + index"
                      />
                    </a-tooltip>
                  </template>
                </a-list-item>
              </template>
            </a-list>
          </div>
          <br />
          <!-- <a-button
            type="primary"
            class="mx-auto"
            :loading="isUploading"
            :disabled="isDisabled"
            @click="uploadVideos"
            id="validatetb-upload-videos-btn"
            >{{ isUploading ? 'Uploading' : 'Upload' }}</a-button
          > -->
          <br />
          <p v-if="isUploading">{{ `Uploading file ${uploadingFileName}` }}</p>
          <a-progress v-if="isUploading" :percent="progress" />
        </a-col>
      </a-row>
    </template>
  </a-modal>
</template>
<script>
import {
  DeleteOutlined,
  EyeOutlined,
  InboxOutlined,
} from '@ant-design/icons-vue';
import axios from 'axios';
import dateHelper from 'src/components/shared/Helpers/dateHelper';
import {
  ModelVersionAiAnnotationColumns,
  modelTypeSelection,
} from 'src/components/user-panel/pages/process/ObjectDetection/config';
import ModelTypeService from 'src/services/modelTypes';
import S3Service from 'src/services/s3';
import { mapGetters } from 'vuex';
import httpClient from '../../../../service/httpClient';

export default {
  components: {
    InboxOutlined,
    DeleteOutlined,
    EyeOutlined,
  },

  inject: ['toast'],

  props: [
    'taskId',
    'taskName',
    'organization',
    'showUploadModal',
    'showModelVersion',
  ],

  emits: [
    'changeTask',
    'handleUploadedFiles',
    'startLoading',
    'setShowUploadModal',
  ],

  setup() {
    return {
      ModelVersionAiAnnotationColumns,
      modelTypeSelection,
      dateHelper,
    };
  },

  data() {
    return {
      fileUrlList: [],
      fileList: [],
      progress: 0,
      uploadingFileName: '',
      isUploading: false,
      videoToPreview: null,
      showVideoModal: false,
      videoFile: null,
      step: 1,
      selectedRow: null,
      modelChoiceId: null,
    };
  },

  computed: {
    ...mapGetters(['modelChoice', 'modelVersionsList']),

    isDisabled() {
      return this.fileList.length === 0 || this.isUploading;
    },

    sortedModelVersionList() {
      if (!this.modelVersionsList.length) return [];
      const sorted = this.modelVersionsList.filter(
        (mv) => !mv.is_deleted && mv.model_type === this.modelChoiceId
      );
      return sorted;
    },

    rowSelection() {
      return {
        type: 'radio',
        selectedRowKeys: [this.selectedRow],
        onChange: this.onRowSelect,
      };
    },

    getButtonText() {
      return this.step === 1
        ? 'Next'
        : this.isUploading
        ? 'Uploading'
        : 'Upload';
    },

    isProceedButtonDisabled() {
      if (this.step === 1 && !this.selectedRow) return true;
      else if (this.step === 2 && this.isDisabled) return true;
      return false;
    },
  },

  watch: {
    showUploadModal: {
      immediate: true,
      handler(value) {
        if (value) {
          if (this.showModelVersion) this.setModelTypeId();
          else this.step = 2;
        } else this.reset();
      },
    },
  },

  methods: {
    reset() {
      this.fileUrlList = [];
      this.fileList = [];
      this.progress = 0;
      this.uploadingFileName = '';
      this.isUploading = false;
      this.videoToPreview = null;
      this.showVideoModal = false;
      this.step = 1;
      this.selectedRow = null;
      this.modelChoiceId = null;
    },

    handleOk() {
      if (this.step === 1 && this.selectedRow) {
        this.step = 2;
        return;
      } else if (this.step === 2) {
        this.uploadVideos();
      }
    },

    onRowSelect(selectedRowKeys) {
      this.selectedRow = selectedRowKeys[0];
    },

    handleUploadModalCancel() {
      this.$emit('setShowUploadModal', false);
    },

    handleBack() {
      if (this.step > 1) {
        this.step -= 1; // Navigate back one step
      }
    },

    async setModelTypeId() {
      if (!this.modelChoice) return;
      const [error, data] = await ModelTypeService.fetchModelTypes();
      if (error || !data?.length) return;
      const modelChoiceObj = data.find((obj) => obj.name === this.modelChoice);
      if (!modelChoiceObj) return;
      this.modelChoiceId = modelChoiceObj.id;
    },

    isFileExist(file) {
      return this.fileList
        .map((e) => e.name + e.size)
        .includes(file.name + file.size);
    },

    getTimeStampFile(file) {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const timestampUTC = `${now.getUTCFullYear()}${pad(
        now.getUTCMonth() + 1
      )}${pad(now.getUTCDate())}${pad(now.getUTCHours())}${pad(
        now.getUTCMinutes()
      )}${pad(now.getUTCSeconds())}${pad(now.getUTCMilliseconds())}`;

      const baseName = file.name.substring(0, file.name.lastIndexOf('.'));
      const fileExtension = file.name.substring(file.name.lastIndexOf('.'));
      const newFileName = `${baseName}_${timestampUTC}${fileExtension}`;
      return new File([file], newFileName, { type: file.type });
    },

    handleAddFile({ file }) {
      const newFile = this.getTimeStampFile(file);
      if (this.isFileExist(newFile)) {
        this.toast.info(`${newFile.name} already exists!`, {
          timeout: 2000,
        });
        return;
      }
      if (newFile.name.includes('.mp4') || newFile.name.includes('.mkv')) {
        newFile['fileURL'] = URL.createObjectURL(newFile);
        this.fileList = [...this.fileList, newFile];
      }
    },
    getFileSize(sizeInBytes) {
      return (sizeInBytes / 1024 / 1024).toFixed(2) + ' MB';
    },
    handlePreview(file) {
      this.videoToPreview = file;
      this.showVideoModal = true;
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter((f) => f.uid !== file.uid);
    },
    async getPresignedURL(taskName, imageName) {
      let payload = {
        bucket: `${this.organization}-videos`,
        key: `validation/${taskName}/Videos/${imageName}`,
      };
      const [error, data] = await S3Service.getPresignedPostURL(payload, false);
      return error ? error : data;
    },
    createAWSFormData(file, data) {
      let awsformData = new FormData();
      Object.keys(data.fields).forEach((key) => {
        awsformData.append(key, data.fields[key]);
      });
      awsformData.append('file', file);
      return awsformData;
    },
    async generatePublicUrl(taskName, imageName) {
      const [error2, url] = await S3Service.generatePresignedUrl(
        `${this.organization}-videos`,
        `validation/${taskName}/Videos/${imageName}`
      );
      if (error2) {
        console.log('Error:', error2);
        return;
      }
      return url;
    },
    async generateThumbnailUrl(taskName, imageName, publicFileUrl) {
      const payload = {
        bucket_name: `${this.organization}-videos`,
        file_path: `validation/${taskName}/Videos/${imageName}`,
        file_url: publicFileUrl,
      };
      const [error2, url] = await S3Service.uploadThumbnailToS3(payload);
      if (error2) {
        console.log('Error:', error2);
        return;
      }
      return url;
    },

    async uploadVideos() {
      for (const file in this.fileList) {
        const post_presigned_url = await this.getPresignedURL(
          this.taskName,
          this.fileList[file].name
        );
        const awsformData = this.createAWSFormData(
          this.fileList[file],
          post_presigned_url
        );

        const headers = {
          'Content-Type': 'multipart/form-data',
          Accept: '*/*',
        };
        this.isUploading = true;
        await axios.post(post_presigned_url.url, awsformData, {
          headers,
          onUploadProgress: (progressEvent) => {
            this.progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        });
        this.isUploading = false;
        this.progress = 0;
        const fileUrl = await this.generatePublicUrl(
          this.taskName,
          this.fileList[file].name
        );
        const publicUrl = `${fileUrl.presigned_url}`;
        const thumbnailUrl = await this.generateThumbnailUrl(
          this.taskName,
          this.fileList[file].name,
          publicUrl
        );
        this.fileUrlList.push({
          file_url: publicUrl,
          thumbnail_path: thumbnailUrl.thumbnail_path,
          video_name: this.fileList[file].name,
        });
      }
      const modelVersion = this.modelVersionsList.find(
        (mv) => mv.id == this.selectedRow
      );
      this.files = [];
      this.$emit('handleUploadedFiles', this.fileUrlList, modelVersion?.id);
      this.fileUrlList = [];
    },

    createFormData(file, name) {
      let formData = new FormData();
      formData.append('task_id', this.taskId);
      formData.append('Validation', 'True');
      formData.append(name, file);
      formData.append('is_validation_record', 'True');
      return formData;
    },

    async upload(fileName, data) {
      if (!this.taskId) {
        this.toast.warning('Please first select the task');
        return;
      }
      this.isUploading = true;
      this.uploadingFileName = fileName;

      const res = await httpClient.upload(
        'organization/task/upload/',
        data,
        this
      );
      this.progress = 0;
      this.isUploading = false;
      if (res === 'error') {
        this.toast.error('Error occured while upload the file.');
        return;
      }
      const videoId = res.data['Successfully uploaded'][0];
      this.files = [];
      return videoId;
    },
  },
};
</script>
<style scoped>
.list-container {
  max-height: 35vh;
  overflow-y: auto;
}
</style>
